import css from './ShimmerLoader.module.css';

interface ShimmerLoaderProps {
    children?: React.ReactNode;
}

export const ShimmerLoader: React.FC<ShimmerLoaderProps> = ({ children }) => {
    return <div className={css.loaderContainer}>{children}</div>;
};
